import React, { useCallback } from "react";
import { ReactComponent as SwitchImage } from "../../Assets/NotFound/switch.svg";
import ComputerImages from "../../Assets/NotFound/computer.svg";
import { GreenButton } from "../../Components/Button/CustomButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import "./NotFound.scss";

const NotFound = () => {
  const navigate = useNavigate();
  const goBackToHome = useCallback(
    () => navigate("/", { replace: true }),
    [navigate]
  );
  return (
    <div className="notfound-container">
      <div className="notfound-inner-container">
        <div className="notfound-message">
          <h1>Oops... </h1>
          <h2>Page not found </h2>
          <h3>
            This Page does not exist or was removed!<br />
            We suggest you go back to home.
          </h3>
          <GreenButton sx={{ padding:'10px'}} onClick={goBackToHome} startIcon={<ArrowBackIcon />}>
            Back to home
          </GreenButton>
        </div>
        <div className="switch-image">
          <SwitchImage />
        </div>
        <div className="computer-image">
          <img src={ComputerImages} alt="computer" />
        </div>
      </div>
    </div>
  );
};

export default NotFound;
